import { render, staticRenderFns } from "./TabContentThumbnail.vue?vue&type=template&id=f80bacd8&scoped=true"
import script from "./TabContentThumbnail.vue?vue&type=script&lang=js"
export * from "./TabContentThumbnail.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/TabContentThumbnail/TabContentThumbnail.less?vue&type=style&index=0&id=f80bacd8&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80bacd8",
  null
  
)

export default component.exports